import { ElementRef, Inject, Injectable } from '@angular/core';

import { isElementWithinQuery } from 'src/app/utils/functions/is-element-within-query';
import { WINDOW } from 'src/app/utils/window.token';

const MODAL_QUERY = 'ccwb-modal';

@Injectable({
  providedIn: 'root'
})
export class IsWithinModalService {
  public constructor(@Inject(WINDOW) private readonly win: Window) {}

  public checkElement(element: HTMLElement | ElementRef): HTMLElement | undefined {
    return isElementWithinQuery(element, MODAL_QUERY, this.win);
  }
}
